import { useDialog } from "@shared/features/dialog/useDialog";
import { useMobileMenu } from "@shared/features/mobileMenu/useMobileMenu";
import { usePlatform } from "@platform/PlatformContext";
import { useHandleNavigationClick } from "@shared/features/mobileMenu/useHandleNavigationClick";
import { MarketingNavigationItems } from "./MarketingNavigationItems";

export function MarketingNavigationItemsContainer() {
  const { openDialog } = useDialog();

  const { user } = usePlatform();

  const { closeMobileMenu } = useMobileMenu();

  const { handleNavigationAnchorClick, handleNavigationClick } =
    useHandleNavigationClick();

  const handleSignupClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    closeMobileMenu();
    openDialog("code");
  };

  return (
    <MarketingNavigationItems
      onNavigationClick={handleNavigationClick}
      onNavigationAnchorClick={handleNavigationAnchorClick}
      onSignupClick={handleSignupClick}
      user={user}
    />
  );
}

export default MarketingNavigationItemsContainer;
